import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=423d3348"
import script from "./SendCode.vue?vue&type=script&lang=js"
export * from "./SendCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports